module.exports = __webpack_public_path__ + "img/new-alt-bg.462607aa.png";